import React, { useState } from 'react'
import { FileDragDrop } from 'components/FileDragDrop'

export function FileDragDropMock(): React.ReactElement {
  const [file, setFile] = useState<File | null>(null)
  return (
    <div className="w-full max-w-sm">
      <FileDragDrop
        file={file}
        onFileChange={setFile}
        supportText="PDF, PNG, JPG up to 10MB"
      />
    </div>
  )
}
